import { createAction, props } from '@ngrx/store';
// ========= Article Management ==========
export const setArticleListPageNumber = createAction('[User Management] Set Article List Page Number', props<{ pageNumberArticleList: number }>());
export const setArticleListItemsPerPage = createAction('[User Management] Set Article List Items Per Page', props<{ itemsPerPageArticleList: number }>());
// ========= Poll Management ==========
export const setPollListPageNumber = createAction('[User Management] Set Poll List Page Number', props<{ pageNumberPollList: number }>());
export const setPollListItemsPerPage = createAction('[User Management] Set Poll List Items Per Page', props<{ itemsPerPagePollList: number }>());
// ========= Category Management ==========
export const setCategoryListPageNumber = createAction('[User Management] Set Category List Page Number', props<{ pageNumberCategoryList: number }>());
export const setCategoryListItemsPerPage = createAction('[User Management] Set Category List Items Per Page', props<{ itemsPerPageCategoryList: number }>());

export const setArticleListFilters = createAction(
  '[Article List] Set Filters',
  props<{ filters: any }>()
);

export const clearArticleListFilters = createAction('[Article List] Clear Filters');